<div class="container">
  <div class="login-section">
    <img class="logo" src="assets/images/sparkly_logo.png" alt="Logo">
    <div class="header">
      <h1 *ngIf="!processSuccessful" translate>register.title</h1>
      <p *ngIf="!processSuccessful">Erstelle einen kostenlosen Sparkly-Account</p>
    </div>
    <ng-container *ngIf="!processSuccessful">
      <form class="login-form" (ngSubmit)="submit()">
        <!--<div class="social-login-buttons">
          <button type="button" (click)="socialRegister('google')">
            <i-tabler name="brand-google"></i-tabler>
            <span>Anmelden mit Google</span>
          </button>
          <button type="button">
            <i-tabler name="brand-apple"></i-tabler>
            <span>Anmelden mit Apple</span>
          </button>
        </div>
        <app-divider [text]="'oder'"></app-divider>-->

        <app-text-input [control]="getControl('name')" [label]="'register.first_name' | translate" [placeholder]="'register.first_name_placeholder' | translate"></app-text-input>
        <app-text-input [control]="getControl('email')"  [label]="'register.email' | translate" [placeholder]="'register.email_placeholder' | translate"></app-text-input>
        <app-text-input [control]="getControl('password')" [label]="'register.password' | translate" [placeholder]="'register.password_placeholder' | translate" type="password"></app-text-input>
        <app-button [text]="'register.submit' | translate" [loading]="loading" type="submit"></app-button>
      </form>
      <p class="login-option">{{'register.login_info' | translate}} <a href="/login">{{'register.login' | translate}}</a></p>
    </ng-container>
    <ng-container *ngIf="processSuccessful">
      <app-success-screen
      [title]="'Bestätige deinen Account'"
      [message]="'Dein Konto wurde erfolgreich erstellt. Bitte bestätige deinen Account über den Link, den wir dir gerade per Mail an ' + this.submittedEmail + ' gesendet haben.'"
      [buttonText]="'register.go_to_login' | translate"
      (buttonClicked)="goToLogin()"></app-success-screen>
    </ng-container>
  </div>

  <div class="hero-section">
    <!--<img class="image" src="assets/images/ki-generierte-karteikarten.png" alt="Logo">-->
    <div>
      <h1>Karteikarten lernen<br><span>revolutioniert</span> mit KI</h1>
      <div class="benefits-container">
        <div class="benefit">
          <i-tabler name="cards"></i-tabler>
          <span>Karteikarten blitzschnell mit KI erstellen</span>
        </div>
        <div class="benefit">
          <i-tabler name="brain"></i-tabler>
          <span>Wiederhole Karteikarten mit 3 smarten Lernmodi effizienter und nachhaltiger</span>
        </div>
        <div class="benefit">
          <i-tabler name="file-text-ai"></i-tabler>
          <span>Teste dein Wissen mit KI-Probeklausuren</span>
        </div>
      </div>
    </div>
  </div>
</div>